<template >
    <div class="excavate-statistics">
        <div class="info-tip"><em></em> 统计结果以饼状图、折线图、柱状图、表格的形式进行展示并且下载，计算统计结果中的总个数、总频次、总案例数，可以通过修改统计个数展示不同的统计结果。</div>
        <div class="info-statistics" >
            <div class="statistics-list" :class="(index+1)%2==0?'bg-color':''" v-for="(item,index) in statisticsList" :key="index">
                <div class="list-top" >{{ item.value }}</div>
                <ul class="list">
                    <li v-for="(list,num) in item.list" :key="num">
                        <el-button  @click='echart_click(list)' type="primary" size="small"> {{ list.value }}</el-button>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 证素和中药属性的弹层 -->
         <statisticsModel :show.sync='isShowMode' >
            <div class="cont" slot="content" >
                <el-button type="primary" plain  v-for='(item,index) in modelData' :key="index"  @click="change_radio(item.type)" >{{item.value}}</el-button>
            </div>
        </statisticsModel>
        <!-- loading 以防数据请求时间长， -->
        <!-- <div v-if='isLoad' class="info-load">
            <div class="loading"></div>
        </div>
        <div v-else> -->
            <!-- 图像 -->
            <echartInfo v-if="isShowEacht" @getInfo="getInfo" :isRadar='isRadar'></echartInfo>
        <!-- </div> -->
    </div>
</template>
<script>
import {mapState,mapMutations,mapActions} from 'vuex'
import echartInfo from './statistics/echart_info.vue'
import statisticsModel from './statistics/statistics_model.vue'
import {toChart} from '../../io/api.js'
import excavateData from './comps/excavateData.js'
// import radar from './statistics/radar.vue'
export default {
    components: {
        echartInfo,
        statisticsModel,
        // radar
    },
    data() {
        return {
            isShowMode:false,
            modelData:[],
            // 统计列表数据
            statisticsList:excavateData.statisticsList,
            // tab切换
            echartTab:excavateData.echartTab,
            // 是否显示雷达图按钮
            isRadar:false,
            // 显示图
            // isShowEacht:false,
        }
    },
    computed: {
        ...mapState({
            isShowEacht:state=>state.excavate.isShowEacht,
            chartType:state=>state.excavate.chartType,
            isLoad:state=>state.excavate.isLoad,
            chartType:state=>state.excavate.chartType,
        })
    },
    methods: {
        ...mapMutations(['','seteEchartData','setModelTitle','setChartType','setIsTcm','setIsLocation','setLoad']),

        ...mapActions(['getChart']),
        leftNavTab(type) {
            this.navIndex = type;
        },
        echart_click(item){
            // item.type!='layerType' 改选项下有弹层
            if(this.chartType==item.type&&item.type!='layerType') return
            // 默认图表为饼图
            this.$store.state.excavate.navType="pie";
            // 重新加载的时候恢复默认值
            this.$store.state.excavate.statisticsData.selsectNum = 10;
            // 中药统计有方剂识别，新开页面
            if(item.value=='证素统计'||item.value=='中药属性'){
                this.isShowMode = true;
                this.modelData = item.change
                this.setModelTitle(item.value)
            }else{
                this.isRadar = false;
                this.setChartType(item.type)
                this.setIsTcm(false)
                this.setIsLocation(false)
                this.getInfo()
            }
        },
        getInfo(){
            let params={
                chartType:this.chartType,
                selectNum:this.$store.state.excavate.statisticsData.selsectNum||10,
            }
            // 请求的时候load为true
            this.setLoad(true)
            this.getChart(params);
        },
        change_radio(val){ 
            this.setChartType(val)
            if(val=='location'||val=='nature'){
                this.setIsLocation(true)
                this.setIsTcm(false)

            }else if(val=='four'||val=='five'||val=='tropism'){
                // 中药属性里功效没有雷达图,其他三个属性里的统计个数不可修改
                this.isRadar = true;
                this.setIsTcm(true)
                this.setIsLocation(false)
                this.$store.state.excavate.radarEchart = excavateData.radarEchart[val]
            }else{
                this.setIsTcm(false)
                this.setIsLocation(false)
                this.isRadar = false;
            }
            this.isShowMode = false;
            this.getInfo()
        },
        
        
    },
}
</script>